module.exports = __webpack_public_path__ + "img/0dd7105.png";